import Icon from 'components/icons/icons'
import { ConnectionStates } from 'interfaces/connection'
import { getConnectionColor, getConnectionIcon, getConnectionLabelText } from 'lib/connection/connection'

interface DynamicLinkProps {
  status?: ConnectionStates
}

const DynamicLink = ({ status = ConnectionStates.GOOD }: DynamicLinkProps) => {
  const color = getConnectionColor(status)
  const iconName = getConnectionIcon(status)
  const label = getConnectionLabelText(status)

  return (
    <div className="group-setup-connection" data-color={color}>
      <span className="group-setup-connection__icon">
        <Icon name={iconName} size={28} />
      </span>
      <span className="group-setup-connection__text">{label}</span>
    </div>
  )
}

export default DynamicLink
